// extracted by mini-css-extract-plugin
export default {"cls1":"CBC0_4akdHTCHxQFF2ME","cls2":"eNb85uGsYDchWejAOZPB CBC0_4akdHTCHxQFF2ME"};